import { useState } from "react";
import Recommendation from "../common/recommendation";

const SortableList = ({ destination, items = [], onSortEnd, destinationTabs, section }) => {
  const [saving, setSaving] = useState(false);
  const move = async (from, to) => {
    if (saving || to < 0 || to >= items.length) return;
    const ids = items.map((item) => item.recommendation_id);
    ids.splice(to, 0, ids.splice(from, 1)[0]);
    setSaving(true);
    try {
      await onSortEnd(ids);
    } catch {
      window.alert("Unable to save recommendation order. Please try again.");
    } finally {
      setSaving(false);
    }
  };
  let mapIndex = 0;
  return <ul className="drag-container uk-list">
    {items.map((item, index) => {
      const hasLoc = !!item.lat && !!item.lng;
      return <Recommendation key={item.recommendation_id} rec={item}
        destination={destination} orderNo={hasLoc ? mapIndex++ : null}
        tabId={destinationTabs?.at(section)} reorderIndex={index}
        reorderCount={items.length} onMove={move} reordering={saving} />;
    })}
  </ul>;
};
export default SortableList;
